"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M6 9a1 1 0 011 1v5a1 1 0 01-1 1H1a1 1 0 01-1-1v-5a1 1 0 011-1h5zM15 9a1 1 0 011 1v5a1 1 0 01-1 1h-5a1 1 0 01-1-1v-5a1 1 0 011-1h5zM15 0a1 1 0 011 1v5a1 1 0 01-1 1H1a1 1 0 01-1-1V1a1 1 0 011-1h14z"];
//# sourceMappingURL=layout-bottom-row-two-tiles.js.map